import BulletList from '@assets/icons/bullet-list.svg'
import { Icon } from './Icon'

export const BulletListIcon = Icon(BulletList)
